<div class="flex flex-column items-center">
  <img
    src="https://portal.ohlq.com/Portals/0/OHLQ_2_color_horizontal_TM.jpg?ver=2019-07-29-112714-850"
    alt="OHLQ"
    style="max-width: 147px;"
  />
  <h2 class="flex-1 text-center fizz-stack-32" style="max-width: 220px;">
    We've partnered with OHLQ!
  </h2>
</div>
<div class="bg-neutral rounded-sm fizz-inset-horizontal-16 fizz-inset-vertical-24 fizz-stack-32">
  <h4 class="fizz-text-strong text-center fizz-stack-24">
    <p>Coming Soon</p>
  </h4>
  <p class="text-center fizz-text-subdued fizz-stack-4 fizz-text-large"
    >You’ll be able to order high proof spirits and liquor on Provi soon!</p
  >
</div>
